<ion-header>
  <ion-toolbar>
    <ion-title>Choose tap</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid style="height: 100%; display: flex; flex-flow: column">
    <ion-row>
      @for (tap of taps(); track tap) {
        <ion-col
          size-xs="12"
          size-md="6"
          >
          <ion-card
            button="true"
            class="ion-no-margin ps-h-100"
            (click)="selectTap(tap)"
            [ngClass]="{'card-active': tap.kegId === keg.id}"
            >
            <ion-card-content>
              <ion-item lines="none">
                <ion-text>
                  <h2>{{ tap.name }}</h2>
                  @if (!!tap.keg?.name) {
                    <ul class="ion-item-list list-inline-note">
                      <li>
                        <ion-icon name="beer-outline"></ion-icon>
                        <span>{{ tap.keg?.name }} {{ tap.keg?.beverage?.name }}</span>
                      </li>
                    </ul>
                  }
                </ion-text>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      }
    </ion-row>
  </ion-grid>
</ion-content>
